import { render } from "./NavPills.vue?vue&type=template&id=5b0222c8&scoped=true"
import script from "./NavPills.vue?vue&type=script&lang=js"
export * from "./NavPills.vue?vue&type=script&lang=js"

import "./NavPills.vue?vue&type=style&index=0&id=5b0222c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0222c8"]])

export default __exports__